<template>
  <div class="checkout-table-row vld-parent" ref="checkoutTableRow">
    <template v-if="$mq == 'xs'">
      <div class="checkout-table-column checkout-table-column-force-fill">
        <div class="d-flex justify-content-between">
          <button
            v-if="itemDeletable"
            type="button"
            class="btn btn-sm btn-red"
            @click="removeItemButton">
            <span class="material-icons">delete</span>
          </button>
          <template v-if="forARoomSlot">
            <img :alt="roomForItem.name" :src="'/img/mp/mp-ls-' + roomForItem.nickname + '.jpg'" width="100" class="mr-2">
            <div class="d-flex align-items-center">
              <p class="text-shadow-highlight ml-1 mb-0 heading" :class="'text-' + roomForItem.nickname">{{ roomForItem.name }}</p>
              <p class="font-italic ml-1 mb-0" v-if="item.options && item.options.subRoomSelected && item.options.subRoomSelected != 'TBC'"><span class="font-weight-bold">Selected Subroom:</span> {{ item.options.subRoomSelected }}</p>
            </div>
          </template>
          <template v-else-if="thingable_type == 'App\\Models\\Voucher' || thingable_type == 'App\\Models\\VoucherProduct'">
            <img :src="location.mpVoucherLandscapeSrc" alt="Gift Voucher" width="100" class="mr-2">

            <div class="d-flex align-items-center">
              <p class="mb-0 heading ml-2 text-cs-green text-shadow-highlight">Gift Voucher</p>
            </div>
          </template>

          <template v-else-if="thingable_type == 'App\\Models\\VirtualGame'">
            <img :alt="thingable.name" :src="'/img/mp/mp-ls-' + thingable.nickname + '.jpg'" width="120" class="mr-2">
            <div class="d-flex align-items-center">
              <p class="mb-0 text-shadow-highlight" :class="'heading text-' + thingable.nickname">{{ thingable.name }}</p>
            </div>
          </template>

          <template v-else-if="thingable_type == 'App\\Models\\Product'">
            <img :alt="thingable.name" :src="thingable.imageUrl ? thingable.imageUrl : '/img/sale/product.jpg'" width="120" class="mr-2">
            <div class="d-flex align-items-center">
              <p class="text-shadow-highlight heading text-tempus-blue-tint">{{ thingable.name }}</p>
            </div>

            <!-- TODO: check these names and class-->
            <!-- <p
              v-if="item.options && item.options.for_room_slot_id"
              class="mb-0"
              :class="'font-italic text-' + cart.cart_items.find(i => i.cartable_type == 'App\\Models\\RoomSlot' && i.cartable_id == item.options.for_room_slot_id).cartable.nickname"
              style="font-size: 85%;">
              for {{ cart.cart_items.find(i => i.cartable_type == 'App\\Models\\RoomSlot' && i.cartable_id == item.options.for_room_slot_id).cartable.name }}
            </p> -->
            <!-- TODO: check these names and class-->
            <!-- <p
              v-else-if="item.options && item.options.for_room_slot_id"
              class="mb-0"
              :class="'font-italic text-' + item.id"
              style="font-size: 85%;">
              for {{ item.id }}
            </p> -->

          </template>

        </div>
      </div>

      <div class="checkout-table-column py-0">
        <div class="row">
          <div class="col">
            <p class="mb-0" v-if="item.cartable_type && item.cartable_type == 'App\\Models\\VoucherProduct' && item.cartable.type == 'M' && item.cartable.amount == 1">
              Money Voucher For {{ item.expectedPrice | money }}
            </p>
            <p class="mb-0" v-else>{{ item.description }}</p>
            <p
              v-if="roomForItem && roomForItem.caveat"
              v-html="roomForItem.caveat"
              class="text-hot-pink mb-0"
              style="font-size: 11px; line-height: 15px">
            </p>
          </div>
        </div>
      </div>

      <div class="checkout-table-column checkout-table-column-100 py-0">
        <template v-if="forARoomSlot">
          <template v-if="bookingQuantityEditable">
            <p v-if="locationChildPricing && item.saleable.children" class="mb-0 font-weight-bold">For {{ item.saleable.adults }} adults, {{ item.saleable.children }} {{ item.saleable.children == 1 ? 'child' : 'children' }}</p>
            <p v-else class="mb-0 font-weight-bold">For {{ item.saleable.adults }} players</p>
          </template>
          <template v-else-if="hasSomeFormOfChildPricing">
            <div class="input-group w-100">
              <div class="input-group-prepend">
                <button
                  v-if="type == 'cart'"
                  class="btn btn-red"
                  type="button"
                  :disabled="disableReduceAdultQtyButton"
                  @click="itemAdultsChanged(-1)">&minus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-red"
                  type="button"
                  :disabled="disableReduceAdultQtyButton"
                  @click="itemAdultsChanged(-1)">&minus;</button>

                <button
                  v-if="type == 'cart'"
                  class="btn btn-green"
                  type="button"
                  :disabled="disableIncreaseAdultQtyButton"
                  @click="itemAdultsChanged(1)">&plus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-green"
                  type="button"
                  :disabled="disableIncreaseAdultQtyButton"
                  @click="itemAdultsChanged(1)">&plus;</button>
              </div>

              <input
                v-if="type == 'cart'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.options.adults">
              <input
                v-else-if="type == 'sale'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.saleable.adults">

              <div class="input-group-append">
                <span class="input-group-text font-weight-bold">adults</span>
              </div>
            </div>

            <div class="input-group mt-2">
              <div class="input-group-prepend">
                <button
                  v-if="type == 'cart'"
                  class="btn btn-red"
                  type="button"
                  :disabled="disableReduceChildrenQtyButton"
                  @click="itemChildrenChanged(-1)">&minus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-red"
                  type="button"
                  :disabled="disableReduceChildrenQtyButton"
                  @click="itemChildrenChanged(-1)">&minus;</button>

                <button
                  v-if="type == 'cart'"
                  class="btn btn-green"
                  type="button"
                  :disabled="disableIncreaseChildrenQtyButton"
                  @click="itemChildrenChanged(1)">&plus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-green"
                  type="button"
                  :disabled="disableIncreaseChildrenQtyButton"
                  @click="itemChildrenChanged(1)">&plus;</button>
              </div>

              <input
                v-if="type == 'cart'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.options.children">
              <input
                v-else-if="type == 'sale'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.saleable.children">

              <div class="input-group-append">
                <span class="input-group-text font-weight-bold">children</span>
              </div>
            </div>
          </template> <!-- v-if="locationChildPricing" -->
          <template v-else>
            <p v-if="bookingQuantityEditable" class="mb-0 font-weight-bold">For {{ item.saleable.adults }} players</p>
            <div v-else class="input-group checkout-table-column-px160">
              <div class="input-group-prepend">
                <button
                  v-if="type == 'cart'"
                  class="btn btn-red"
                  type="button"
                  :disabled="roomForItem.play_min == item.quantity"
                  @click="itemAdultsChanged(-1)">&minus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-red"
                  type="button"
                  :disabled="roomForItem.play_min == thingable.adults"
                  @click="itemAdultsChanged(-1)">&minus;</button>
              </div>

              <input
                v-if="type == 'cart'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.quantity">
              <input
                v-else-if="type == 'sale'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="thingable.adults">
              <div class="input-group-append">
                <button
                  v-if="type == 'cart'"
                  class="btn btn-green"
                  type="button"
                  :disabled="thingable.availableRemainingTickets - item.quantity == 0"
                  @click="itemAdultsChanged(1)">&plus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-green"
                  type="button"
                  :disabled="thingable.players >= thingable.room_slot.room.play_max"
                  @click="itemAdultsChanged(1)">&plus;</button>
              </div>
            </div>
          </template>
        </template>
        <template v-else> <!-- NOT FOR A RoomSlot || Booking -->
          <p v-if="! itemQuanityEditable" class="mb-0 font-weight-bold">
            <template v-if="item.cartable_type && item.cartable_type == 'App\\Models\\VoucherProduct' && item.cartable.type == 'M' && item.cartable.amount == 1">
              &times;1
            </template>
            <template v-else>
              &times;{{ item.quantity }}
            </template>
          </p>
          <div v-else class="input-group input-group-sm">
            <div class="input-group-prepend">
              <button
                class="btn btn-red"
                type="button"
                :disabled="1 == item.quantity"
                @click="itemQuantityChanged(-1)">&minus;</button>
            </div>

            <input
              type="number"
              min="1"
              class="form-control no-number-spinner"
              disabled="disabled"
              style="width: 50px;"
              v-model.number="item.quantity">

            <div class="input-group-append">
              <button
                class="btn btn-green"
                type="button"
                @click="itemQuantityChanged(1)">&plus;</button>
            </div>
          </div>
        </template>
        <template v-if="type == 'cart' && forARoomSlot && roomQuestions[itemRoomId]">
          <room-questions-response-crud
            :ref="'rqrd_ci' + item.id"
            v-model="item.cart_item_question_responses"
            :room-questions="roomQuestions[itemRoomId]"
            :cart-item="item"></room-questions-response-crud>
        </template>
        <template v-else-if="type == 'sale' && forARoomSlot && roomQuestions[itemRoomId]">
          <room-questions-response-crud
            :ref="'rqrd_si' + item.id"
            v-model="item.sale_item_question_responses"
            :room-questions="roomQuestions[itemRoomId]"
            :sale-item="item"></room-questions-response-crud>
        </template>

        <p v-if="type == 'cart' && ! item.canBeCheckedOut" class="mt-2 mb-0 font-italic text-orange" data-toggle="tooltip" title="It is likely that this RoomSlot has been purchased by somebody else.">
          <span class="material-icons">warning</span> Apologies, this Room Slot is no longer available
        </p>
      </div>

      <div class="checkout-table-column">
        <p class="mb-0">{{ (type == 'cart' ? item.price : item.sold_for) | money }}</p>
      </div>
    </template>

    <template v-else-if="($mq == 'sm' || $mq == 'md')">
      <div class="checkout-table-column checkout-table-column-px140"> <!-- ITEM -->
        <div class="flex-fill">
          <div v-if="forARoomSlot">
            <img :alt="roomForItem.name" :src="'/img/mp/mp-ls-' + roomForItem.nickname + '.jpg'" width="120" class="mr-2">

            <div>
              <p class="text-shadow-highlight ml-1 mb-0 heading" :class="'text-' + roomForItem.nickname">{{ roomForItem.name }}</p>
              <p class="font-italic ml-1 mb-0" v-if="item.options && item.options.subRoomSelected && item.options.subRoomSelected != 'TBC'"><span class="font-weight-bold">Selected Subroom:</span> {{ item.options.subRoomSelected }}</p>
            </div>

            <button
              v-if="itemDeletable"
              type="button"
              class="btn btn-sm btn-red"
              @click="removeItemButton">
              <span class="material-icons">delete</span>
            </button>
          </div>

          <div v-else-if="thingable_type == 'App\\Models\\Voucher' || thingable_type == 'App\\Models\\VoucherProduct'">
            <img :src="location.mpVoucherLandscapeSrc" alt="Gift Voucher" width="120" class="mr-2">

            <p class="mb-0 heading ml-2 text-cs-green text-shadow-highlight">Gift Voucher</p>

            <button
              v-if="itemDeletable"
              type="button"
              class="btn btn-sm btn-red"
              @click="removeItemButton">
              <span class="material-icons">delete</span>
            </button>

          </div>
          <div v-else-if="thingable_type == 'App\\Models\\VirtualGame'">
            <img :alt="thingable.name" :src="'/img/mp/mp-ls-' + thingable.nickname + '.jpg'" width="120" class="mr-2">
            <p class="mb-0 text-shadow-highlight" :class="'heading text-' + thingable.nickname">{{ thingable.name }}</p>
            <button
              v-if="itemDeletable"
              type="button"
              class="btn btn-sm btn-red"
              @click="removeItemButton">
              <span class="material-icons">delete</span>
            </button>
          </div>
          <div v-else-if="thingable_type == 'App\\Models\\Product'">
            <img :alt="thingable.name" :src="thingable.imageUrl ? thingable.imageUrl : '/img/sale/product.jpg'" width="120" class="mr-2">
            <p class="text-shadow-highlight heading text-tempus-blue-tint">{{ thingable.name }}</p>

            <!-- TODO: check these names and class-->
            <!-- <p
              v-if="item.options && item.options.for_room_slot_id"
              class="mb-0"
              :class="'font-italic text-' + cart.cart_items.find(i => i.cartable_type == 'App\\Models\\RoomSlot' && i.cartable_id == item.options.for_room_slot_id).cartable.nickname"
              style="font-size: 85%;">
              for {{ cart.cart_items.find(i => i.cartable_type == 'App\\Models\\RoomSlot' && i.cartable_id == item.options.for_room_slot_id).cartable.name }}
            </p> -->
            <!-- TODO: check these names and class-->
            <!-- <p
              v-else-if="item.options && item.options.for_room_slot_id"
              class="mb-0"
              :class="'font-italic text-' + item.id"
              style="font-size: 85%;">
              for {{ item.id }}
            </p> -->

            <button
              v-if="itemDeletable"
              type="button"
              class="btn btn-sm btn-red"
              @click="removeItemButton">
              <span class="material-icons">delete</span>
            </button>
          </div>
        </div>
      </div> <!-- /ITEM -->

      <div class="checkout-table-column checkout-table-no-flex" :class="$mq == 'md' ? '' :'checkout-table-column-px300'"> <!-- DETAILS | QTY -->
        <div class="row">
          <div class="col">
            <p class="mb-0" v-if="item.cartable_type && item.cartable_type == 'App\\Models\\VoucherProduct' && item.cartable.type == 'M' && item.cartable.amount == 1">
              Money Voucher For {{ item.expectedPrice | money }}
            </p>
            <p v-else class="mb-0">{{ item.description }}</p>
            <p v-if="thingable_type == 'App\\Models\\VirtualGame'" class="mb-0 text-pink font-italic">This is an Online Virtual Game</p>
            <p
              v-if="roomForItem && roomForItem.caveat"
              v-html="roomForItem.caveat"
              class="text-hot-pink mb-0"
              style="font-size: 11px; line-height: 15px">
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <template v-if="forARoomSlot">
              <template v-if="bookingQuantityEditable">
                <p v-if="locationChildPricing && item.saleable.children" class="mb-0 font-weight-bold">For {{ item.saleable.adults }} adults, {{ item.saleable.children }} {{ item.saleable.children == 1 ? 'child' : 'children' }}</p>
                <p v-else class="mb-0 font-weight-bold">For {{ item.saleable.adults }} players</p>
              </template>
              <template v-else-if="hasSomeFormOfChildPricing">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="input-group mt-2">

                      <div class="input-group-prepend">
                        <button
                          v-if="type == 'cart'"
                          class="btn btn-red"
                          type="button"
                          :disabled="disableReduceAdultQtyButton"
                          @click="itemAdultsChanged(-1)">&minus;</button>
                        <button
                          v-else-if="type == 'sale'"
                          class="btn btn-red"
                          type="button"
                          :disabled="disableReduceAdultQtyButton"
                          @click="itemAdultsChanged(-1)">&minus;</button>

                        <button
                          v-if="type == 'cart'"
                          class="btn btn-green"
                          type="button"
                          :disabled="disableIncreaseAdultQtyButton"
                          @click="itemAdultsChanged(1)">&plus;</button>
                        <button
                          v-else-if="type == 'sale'"
                          class="btn btn-green"
                          type="button"
                          :disabled="disableIncreaseAdultQtyButton"
                          @click="itemAdultsChanged(1)">&plus;</button>
                      </div>

                      <input
                        v-if="type == 'cart'"
                        type="number"
                        min="1"
                        class="form-control no-number-spinner"
                        disabled="disabled"
                        style="width: 50px;"
                        v-model.number="item.options.adults">
                      <input
                        v-else-if="type == 'sale'"
                        type="number"
                        min="1"
                        class="form-control no-number-spinner"
                        disabled="disabled"
                        style="width: 50px;"
                        v-model.number="item.saleable.adults">

                      <div class="input-group-append">
                        <span class="input-group-text font-weight-bold">adults</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="input-group mt-2">
                      <div class="input-group-prepend">
                        <button
                          v-if="type == 'cart'"
                          class="btn btn-red"
                          type="button"
                          :disabled="disableReduceChildrenQtyButton"
                          @click="itemChildrenChanged(-1)">&minus;</button>
                        <button
                          v-else-if="type == 'sale'"
                          class="btn btn-red"
                          type="button"
                          :disabled="disableReduceChildrenQtyButton"
                          @click="itemChildrenChanged(-1)">&minus;</button>

                        <button
                          v-if="type == 'cart'"
                          class="btn btn-green"
                          type="button"
                          :disabled="disableIncreaseChildrenQtyButton"
                          @click="itemChildrenChanged(1)">&plus;</button>
                        <button
                          v-else-if="type == 'sale'"
                          class="btn btn-green"
                          type="button"
                          :disabled="disableIncreaseChildrenQtyButton"
                          @click="itemChildrenChanged(1)">&plus;</button>
                      </div>

                      <input
                        v-if="type == 'cart'"
                        type="number"
                        min="1"
                        class="form-control no-number-spinner"
                        disabled="disabled"
                        style="width: 50px;"
                        v-model.number="item.options.children">
                      <input
                        v-else-if="type == 'sale'"
                        type="number"
                        min="1"
                        class="form-control no-number-spinner"
                        disabled="disabled"
                        style="width: 50px;"
                        v-model.number="item.saleable.children">

                      <div class="input-group-append">
                        <span class="input-group-text font-weight-bold">children</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template> <!-- v-if="locationChildPricing" -->
              <template v-else>
                <p v-if="bookingQuantityEditable" class="mb-0 font-weight-bold">For {{ item.saleable.adults }} players</p>
                <div v-else class="input-group checkout-table-column-px160">
                  <div class="input-group-prepend">
                    <button
                      v-if="type == 'cart'"
                      class="btn btn-red"
                      type="button"
                      :disabled="roomForItem.play_min == item.quantity"
                      @click="itemAdultsChanged(-1)">&minus;</button>
                    <button
                      v-else-if="type == 'sale'"
                      class="btn btn-red"
                      type="button"
                      :disabled="roomForItem.play_min == thingable.adults"
                      @click="itemAdultsChanged(-1)">&minus;</button>
                  </div>

                  <input
                    v-if="type == 'cart'"
                    type="number"
                    min="1"
                    class="form-control no-number-spinner"
                    disabled="disabled"
                    style="width: 50px;"
                    v-model.number="item.quantity">
                  <input
                    v-else-if="type == 'sale'"
                    type="number"
                    min="1"
                    class="form-control no-number-spinner"
                    disabled="disabled"
                    style="width: 50px;"
                    v-model.number="thingable.adults">
                  <div class="input-group-append">
                    <button
                      v-if="type == 'cart'"
                      class="btn btn-green"
                      type="button"
                      :disabled="thingable.availableRemainingTickets - item.quantity == 0"
                      @click="itemAdultsChanged(1)">&plus;</button>
                    <button
                      v-else-if="type == 'sale'"
                      class="btn btn-green"
                      type="button"
                      :disabled="thingable.players >= thingable.room_slot.room.play_max"
                      @click="itemAdultsChanged(1)">&plus;</button>
                  </div>
                </div>
              </template>
            </template>
            <template v-else> <!-- NOT FOR A RoomSlot || Booking -->
              <p v-if="! itemQuanityEditable" class="mb-0 font-weight-bold">
                <template v-if="item.cartable_type && item.cartable_type == 'App\\Models\\VoucherProduct' && item.cartable.type == 'M' && item.cartable.amount == 1">
                  &times;1
                </template>
                <template v-else>
                  &times;{{ item.quantity }}
                </template>
              </p>
              <div v-else class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <button
                    class="btn btn-red"
                    type="button"
                    :disabled="1 == item.quantity"
                    @click="itemQuantityChanged(-1)">&minus;</button>
                </div>

                <input
                  type="number"
                  min="1"
                  class="form-control no-number-spinner"
                  disabled="disabled"
                  style="width: 50px;"
                  v-model.number="item.quantity">

                <div class="input-group-append">
                  <button
                    class="btn btn-green"
                    type="button"
                    @click="itemQuantityChanged(1)">&plus;</button>
                </div>
              </div>
            </template>
            <template v-if="type == 'cart' && forARoomSlot && roomQuestions[itemRoomId]">
              <room-questions-response-crud
                :ref="'rqrd_ci' + item.id"
                v-model="item.cart_item_question_responses"
                :room-questions="roomQuestions[itemRoomId]"
                :cart-item="item"></room-questions-response-crud>
            </template>
            <template v-else-if="type == 'sale' && forARoomSlot && roomQuestions[itemRoomId]">
              <room-questions-response-crud
                :ref="'rqrd_si' + item.id"
                v-model="item.sale_item_question_responses"
                :room-questions="roomQuestions[itemRoomId]"
                :sale-item="item"></room-questions-response-crud>
            </template>

            <p v-if="type == 'cart' && ! item.canBeCheckedOut" class="mt-2 mb-0 font-italic text-orange" data-toggle="tooltip" title="It is likely that this RoomSlot has been purchased by somebody else.">
              <span class="material-icons">warning</span> Apologies, this Room Slot is no longer available
            </p>
          </div>
        </div>
      </div> <!-- DETAILS | QTY -->
    </template> <!-- ($mq == 'sm' || $mq == 'md') -->
    <template v-else> <!-- ($mq == 'lg+') -->
      <div class="checkout-table-column checkout-table-column-px100"> <!-- TOOLS -->
        <button
          v-if="itemDeletable"
          type="button"
          class="btn btn-red"
          @click="removeItemButton">
          <span class="material-icons">delete</span>
        </button>
      </div> <!-- /TOOLS -->

      <div v-if="($mq == 'xl' || $mq == 'lg')" class="checkout-table-column checkout-table-column-px180 checkout-table-no-flex"> <!-- ITEM -->
        <template v-if="forARoomSlot">
          <img :alt="roomForItem.name" :src="'/img/mp/mp-ls-' + roomForItem.nickname + '.jpg'" width="120" class="mr-2">
          <div>
            <p class="text-shadow-highlight ml-2 mb-0 heading" :class="'text-' + roomForItem.nickname" style="max-width: 400px;">{{ roomForItem.name }}</span>
            <p class="font-italic ml-2 mb-0" v-if="item.options && item.options.subRoomSelected && item.options.subRoomSelected != 'TBC'"><span class="font-weight-bold">Selected Subroom:</span> {{ item.options.subRoomSelected }}</p>
          </div>
        </template>

        <template v-else-if="thingable_type == 'App\\Models\\Voucher' || thingable_type == 'App\\Models\\VoucherProduct'">
          <img :src="location.mpVoucherLandscapeSrc" alt="Gift Voucher" width="120" class="mr-2">
          <div>
            <p class="heading ml-2 text-cs-green text-shadow-highlight">Gift Voucher</p>
          </div>
        </template>

        <template v-else-if="thingable_type == 'App\\Models\\VirtualGame'">
          <img :alt="thingable.name" :src="'/img/mp/mp-ls-' + thingable.nickname + '.jpg'" width="120" class="mr-2">
          <p class="text-shadow-highlight" :class="'heading text-' + thingable.nickname">{{ thingable.name }}</p>
        </template>

        <template v-else-if="thingable_type == 'App\\Models\\Product'">
          <img :alt="thingable.name" :src="thingable.imageUrl ? thingable.imageUrl : '/img/sale/product.jpg'" width="120" class="mr-2">
          <p class="text-shadow-highlight heading text-tempus-blue-tint">{{ thingable.name }}</p>
          <!-- TODO: check with other version -->
          <!-- <p
            v-if="item.options && item.options.for_room_slot_id"
            class="mb-0"
            :class="'font-italic text-' + location.rooms.filter(room => room.id == item.options.for_room_id)[0].nickname"
            style="font-size: 85%;">for {{ location.rooms.filter(room => room.id == item.options.for_room_id)[0].name }}</p> -->
        </template>
      </div>

      <div v-if="($mq != 'lg' && $mq != 'xl')"" class="checkout-table-column checkout-table-column-px120"> <!-- ITEM -->
        <div class="row">
          <div class="col" v-if="forARoomSlot">
            <img :alt="roomForItem.name" :src="'/img/mp/mp-ls-' + roomForItem.nickname + '.jpg'" width="120" class="mr-2">
          </div>

          <div class="col" v-else-if="thingable_type == 'App\\Models\\Voucher' || thingable_type == 'App\\Models\\VoucherProduct'">
            <img :src="location.mpVoucherLandscapeSrc" alt="Gift Voucher" width="120" class="mr-2">
          </div>

          <div class="col" v-else-if="thingable_type == 'App\\Models\\VirtualGame'">
            <img :alt="thingable.name" :src="'/img/mp/mp-ls-' + thingable.nickname + '.jpg'" width="120" class="mr-2">
          </div>

          <div class="col" v-else-if="thingable_type == 'App\\Models\\Product'">
            <img :alt="thingable.name" :src="thingable.imageUrl ? thingable.imageUrl : '/img/sale/product.jpg'" width="120" class="mr-2">
          </div>
        </div>
      </div> <!-- /ITEM -->
      <div v-if="$mq != 'lg' && $mq != 'xl'" class="checkout-table-column checkout-table-column-px260"> <!-- ITEM-num-2 -->
        <div class="row">
          <div class="col" v-if="forARoomSlot">
            <p class="text-shadow-highlight ml-2 mb-0 heading" :class="'text-' + roomForItem.nickname">{{ roomForItem.name }}</span>
            <p class="font-italic ml-2 mb-0" v-if="item.options && item.options.subRoomSelected && item.options.subRoomSelected != 'TBC'"><span class="font-weight-bold">Selected Subroom:</span> {{ item.options.subRoomSelected }}</p>
          </div>
          <div class="col" v-else-if="thingable_type == 'App\\Models\\Voucher' || thingable_type == 'App\\Models\\VoucherProduct'">
            <span class="heading ml-2 text-cs-green text-shadow-highlight">Gift Voucher</span>
          </div>
          <div class="col" v-else-if="thingable_type == 'App\\Models\\VirtualGame'">
            <span class="text-shadow-highlight" :class="'heading text-' + thingable.nickname">{{ thingable.name }}</span>
          </div>
          <div class="col" v-else-if="thingable_type == 'App\\Models\\Product'">
            <span class="text-shadow-highlight heading text-tempus-blue-tint">{{ thingable.name }}</span>
            <!-- TODO: check with other version -->
            <!-- <p
              v-if="item.options && item.options.for_room_slot_id"
              class="mb-0"
              :class="'font-italic text-' + location.rooms.filter(room => room.id == item.options.for_room_id)[0].nickname"
              style="font-size: 85%;">for {{ location.rooms.filter(room => room.id == item.options.for_room_id)[0].name }}</p> -->
          </div>
        </div>
      </div> <!-- /ITEM-num-2 -->

      <div class="checkout-table-column" :class="hasSomeFormOfChildPricing ? 'checkout-table-column-px260 checkout-table-no-flex' : 'checkout-table-column-px160'"> <!-- QTY -->
        <template v-if="forARoomSlot">
          <template v-if="bookingQuantityEditable">
            <p v-if="locationChildPricing && item.saleable.children" class="mb-0 font-weight-bold">For {{ item.saleable.adults }} adults, {{ item.saleable.children }} {{ item.saleable.children == 1 ? 'child' : 'children' }}</p>
            <p v-else class="mb-0 font-weight-bold">For {{ item.saleable.adults }} players</p>
          </template>
          <template v-if="hasSomeFormOfChildPricing">
            <div class="input-group">
              <div class="input-group-prepend">
                <button
                  v-if="type == 'cart'"
                  class="btn btn-red"
                  type="button"
                  :disabled="disableReduceAdultQtyButton"
                  @click="itemAdultsChanged(-1)">&minus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-red"
                  type="button"
                  :disabled="disableReduceAdultQtyButton"
                  @click="itemAdultsChanged(-1)">&minus;</button>

                <button
                  v-if="type == 'cart'"
                  class="btn btn-green"
                  type="button"
                  :disabled="disableIncreaseAdultQtyButton"
                  @click="itemAdultsChanged(1)">&plus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-green"
                  type="button"
                  :disabled="disableIncreaseAdultQtyButton"
                  @click="itemAdultsChanged(1)">&plus;</button>
              </div>

              <input
                v-if="type == 'cart'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.options.adults">
              <input
                v-else-if="type == 'sale'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="thingable.adults">

              <div class="input-group-append">
                <span class="input-group-text">adults</span>
              </div>
            </div>

            <div class="input-group mt-2">
              <div class="input-group-prepend">
                <button
                  v-if="type == 'cart'"
                  class="btn btn-red"
                  type="button"
                  :disabled="disableReduceChildrenQtyButton"
                  @click="itemChildrenChanged(-1)">&minus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-red"
                  type="button"
                  :disabled="disableReduceChildrenQtyButton"
                  @click="itemChildrenChanged(-1)">&minus;</button>

                <button
                  v-if="type == 'cart'"
                  class="btn btn-green"
                  type="button"
                  :disabled="disableIncreaseChildrenQtyButton"
                  @click="itemChildrenChanged(1)">&plus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-green"
                  type="button"
                  :disabled="disableIncreaseChildrenQtyButton"
                  @click="itemChildrenChanged(1)">&plus;</button>
              </div>

              <input
                v-if="type == 'cart'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.options.children">
              <input
                v-else-if="type == 'sale'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.saleable.children">

              <div class="input-group-append">
                <span class="input-group-text">children</span>
              </div>
            </div>
          </template> <!-- v-if="locationChildPricing" -->
          <template v-else>
            <div v-if="itemDeletable" class="input-group">
              <div class="input-group-prepend">
                <button
                  v-if="type == 'cart'"
                  class="btn btn-red"
                  type="button"
                  :disabled="roomForItem.play_min == item.quantity"
                  @click="itemAdultsChanged(-1)">&minus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-red"
                  type="button"
                  :disabled="roomForItem.play_min == thingable.players"
                  @click="itemAdultsChanged(-1)">&minus;</button>
              </div>

              <input
                v-if="type == 'cart'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="item.quantity">
              <input
                v-else-if="type == 'sale'"
                type="number"
                min="1"
                class="form-control no-number-spinner"
                disabled="disabled"
                style="width: 50px;"
                v-model.number="thingable.adults">

              <div class="input-group-append">
                <button
                  v-if="type == 'cart'"
                  class="btn btn-green"
                  type="button"
                  :disabled="thingable.availableRemainingTickets - item.quantity == 0"
                  @click="itemAdultsChanged(1)">&plus;</button>
                <button
                  v-else-if="type == 'sale'"
                  class="btn btn-green"
                  type="button"
                  :disabled="thingable.players >= thingable.room_slot.room.play_max"
                  @click="itemAdultsChanged(1)">&plus;</button>
              </div>
            </div>
          </template>
        </template>
        <template v-else-if="thingable_type == 'App\\Models\\Voucher' && thingable.voucher_product.type == 'M' && thingable.voucher_product.amount == 1">&times;1</template>
        <template v-else>
          <p v-if="! itemQuanityEditable" class="mb-0 font-weight-bold">
            <template v-if="item.cartable_type && item.cartable_type == 'App\\Models\\VoucherProduct' && item.cartable.type == 'M' && item.cartable.amount == 1">
              &times;1
            </template>
            <template v-else>
              &times;{{ item.quantity }}
            </template>
          </p>
          <div v-else class="input-group">
            <div class="input-group-prepend">
              <button
                class="btn btn-red"
                type="button"
                :disabled="1 == item.quantity"
                @click="itemQuantityChanged(-1)">&minus;</button>
            </div>

            <input
              type="number"
              min="1"
              class="form-control no-number-spinner"
              disabled="disabled"
              style="width: 50px;"
              v-model.number="item.quantity">

            <div class="input-group-append">
              <button
                class="btn btn-green"
                type="button"
                @click="itemQuantityChanged(1)">&plus;</button>
            </div>
          </div>
        </template>
      </div> <!-- /QTY -->

      <div class="checkout-table-column checkout-table-no-flex my-auto"> <!-- DETAILS -->
        <p class="mb-0" v-if="item.cartable_type && item.cartable_type == 'App\\Models\\VoucherProduct' && item.cartable.type == 'M' && item.cartable.amount == 1">
          Money Voucher For {{ item.expectedPrice | money }}
        </p>
        <p class="mb-0" v-else>{{ item.checkoutTitle }}</p>

        <p v-if="item.checkoutMoreDetails" class="mb-0">{{ item.checkoutMoreDetails }}</p>
        <p v-if="thingable_type == 'App\\Models\\VirtualGame'" class="mb-0 text-pink font-italic">This is an Online Virtual Game</p>
        <p
          v-if="forARoomSlot"
          v-html="roomForItem.caveat"
          class="text-hot-pink mb-0"
          style="font-size: 11px; line-height: 15px">
        </p>

        <template v-if="type == 'cart' && forARoomSlot && roomQuestions[itemRoomId]">
          <room-questions-response-crud
            :ref="'rqrd_ci' + item.id"
            v-model="item.cart_item_question_responses"
            :room-questions="roomQuestions[itemRoomId]"
            :cart-item="item"></room-questions-response-crud>
        </template>
        <template v-else-if="type == 'sale' && forARoomSlot && roomQuestions[itemRoomId]">
          <room-questions-response-crud
            :ref="'rqrd_si' + item.id"
            v-model="item.sale_item_question_responses"
            :room-questions="roomQuestions[itemRoomId]"
            :sale-item="item"></room-questions-response-crud>
        </template>

        <p v-if="type == 'cart' && ! item.canBeCheckedOut" class="mt-2 mb-0 font-italic text-orange" data-toggle="tooltip" title="It is likely that this RoomSlot has been purchased by somebody else.">
          <span class="material-icons">warning</span> Apologies, this Room Slot is no longer available
        </p>
      </div> <!-- DETAILS -->
    </template>

    <!-- NOW BOTH MOBILE (NOT XS) AND DESKTOP -->
    <div v-if="$mq != 'xs'" class="checkout-table-column checkout-table-column-px100" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''"> <!-- PRICE -->
      <p class="mb-0">{{ (type == 'cart' ? item.price : item.sold_for) | money }}</p>
    </div> <!-- /PRICE -->

    <!-- ==================== -->
    <!-- = ROOM ADDONS HERE = -->
    <!-- ==================== -->
    <template v-if="roomProductsForRoomId.length">
      <div class="break mx-4 mb-4">
        <hr class="border-gray-600 mb-0"/>
        <span class="text-muted" style="position: relative; top: -4px;" :style="($mq == 'xs' || $mq == 'sm') ? 'display: block; top: 0; line-height: 1.06;' : 'left:86px'">
          Add-Ons For {{ roomForItem.name }} Are Available
        </span>
      </div> <!-- FORCES NEW ROW -->
      <template v-for="(product, idx) in roomProductsForRoomId">
        <template v-if="($mq == 'xs' || $mq == 'sm')">
          <div class="checkout-table-column pb-0 checkout-table-column-px140 text-right"> <!-- ITEM -->
            <button
              v-if="productIsInBasket(product)"
              class="btn btn-sm btn-red"
              @click="itemAddOnQuantityChanged(addOnItemsByProductId[product.id], -addOnItemsByProductId[product.id].quantity)">
              <span class="material-icons">delete</span>
            </button>
            <button
              v-else
              class="btn btn-sm btn-dark-green"
              @click="addProduct(product)">
              <span class="material-icons">add_shopping_cart</span>
            </button>
          </div>
          <div class="checkout-table-column pb-0 checkout-table-column-px260"> <!-- DETAILS | QTY -->
            <div class="input-group">
              <template v-if="productIsInBasket(product)">
                <div class="input-group-prepend">
                  <button
                    class="btn btn-red"
                    type="button"
                    :disabled="addOnItemsByProductId[product.id].quantity == 0"
                    @click="itemAddOnQuantityChanged(addOnItemsByProductId[product.id], -1)">&minus;</button>
                </div>
                <input
                  type="number"
                  min="0"
                  class="form-control no-number-spinner"
                  :disabled="true"
                  style="width: 50px;"
                  v-model.number="addOnItemsByProductId[product.id].quantity">
                <div class="input-group-append">
                  <button
                    class="btn btn-green"
                    type="button"
                    @click="itemAddOnQuantityChanged(addOnItemsByProductId[product.id], 1)">&plus;</button>
                </div>
              </template>
              <template v-else>
                <div class="input-group-prepend">
                  <button
                    class="btn btn-red"
                    type="button"
                    :disabled="true">&minus;</button>
                </div>
                <input
                  type="number"
                  min="0"
                  class="form-control no-number-spinner"
                  :disabled="true"
                  style="width: 50px;"
                  v-model="zero">
                <div class="input-group-appxend">
                  <button
                    class="btn btn-green"
                    type="button"
                    @click="addProduct(product)">&plus;</button>
                </div>
              </template>
            </div>
            <div>
              <img
                :src="product.imageUrl ? product.imageUrl : '/img/sale/product.jpg'"
                :alt="product.name"
                style="max-width: 100px;"
                class="mr-2 img-fluid">
            </div>
            <p class="font-weight-bold mb-0" style="font-size: 90%;">{{ product.name }}</p>
            <p class="mb-0" style="font-size: 80%;">{{ product.description }}</p>
            <p v-if="product.options.caveat" class="text-hot-pink mb-0" style="font-size: 80%;">{{ product.options.caveat }}</p>
          </div>
        </template>
        <template v-else>
          <div class="checkout-table-column pb-0 checkout-table-column-px100"> <!-- TOOLS -->
          </div> <!-- /TOOLS -->
          <div class="checkout-table-column pb-0 checkout-table-column-px120"> <!-- ITEM -->
            <button
              v-if="productIsInBasket(product)"
              class="btn btn-sm btn-red"
              @click="itemAddOnQuantityChanged(addOnItemsByProductId[product.id], -addOnItemsByProductId[product.id].quantity)">
              <span class="material-icons">delete</span>
            </button>
            <button
              v-else
              class="btn btn-sm btn-dark-green"
              @click="addProduct(product)">
              <span class="material-icons">add_shopping_cart</span>
            </button>
          </div> <!-- /ITEM -->
          <div class="checkout-table-column pb-0 checkout-table-column-px260"> <!-- ITEM-num-2 -->
            <div class="mt-2">
              <img
                :src="product.imageUrl ? product.imageUrl : '/img/sale/product.jpg'"
                :alt="product.name"
                style="max-width: 100px;"
                class="mr-2 img-fluid">
            </div>
            <p class="font-weight-bold mb-0" style="font-size: 90%;">{{ product.name }}</p>
          </div> <!-- /ITEM-num-2 -->

          <div class="checkout-table-column pb-0" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"> <!-- QTY -->
            <div class="input-group">
              <template v-if="productIsInBasket(product)">
                <div class="input-group-prepend">
                  <button
                    class="btn btn-red"
                    type="button"
                    :disabled="addOnItemsByProductId[product.id].quantity == 0"
                    @click="itemAddOnQuantityChanged(addOnItemsByProductId[product.id], -1)">&minus;</button>
                </div>
                <input
                  type="number"
                  min="0"
                  class="form-control no-number-spinner"
                  :disabled="true"
                  style="width: 50px;"
                  v-model.number="addOnItemsByProductId[product.id].quantity">
                <div class="input-group-append">
                  <button
                    class="btn btn-green"
                    type="button"
                    @click="itemAddOnQuantityChanged(addOnItemsByProductId[product.id], 1)">&plus;</button>
                </div>
              </template>
              <template v-else>
                <div class="input-group-prepend">
                  <button
                    class="btn btn-red"
                    type="button"
                    :disabled="true">&minus;</button>
                </div>
                <input
                  type="number"
                  min="0"
                  class="form-control no-number-spinner"
                  :disabled="true"
                  style="width: 50px;"
                  v-model="zero">
                <div class="input-group-append">
                  <button
                    class="btn btn-green"
                    type="button"
                    @click="addProduct(product)">&plus;</button>
                </div>
              </template>
            </div>
          </div> <!-- /QTY -->
          <div class="checkout-table-column pb-0" :class="product.options.caveat ? 'checkout-table-no-flex' : ''" style="max-width: 600px;"> <!-- DETAILS -->
            <p class="mb-0" style="font-size: 80%;" v-if="item.cartable_type && item.cartable_type == 'App\\Models\\VoucherProduct' && item.cartable.type == 'M' && item.cartable.amount == 1">
              Money Voucher For {{ item.expectedPrice | money }}
            </p>
            <p class="mb-0" style="font-size: 80%;" v-else>{{ product.description }}</p>
            <p v-if="product.options.caveat" class="mt-2 mb-0 text-hot-pink" style="font-size: 80%;">{{ product.options.caveat }}</p>
          </div> <!-- /DETAILS -->
        </template>
        <div class="checkout-table-column pb-0" :class="($mq == 'xs' || $mq == 'sm') ? 'checkout-table-column-px160 text-right' : (productIsInBasket(product) ? 'checkout-table-column-px100' : 'checkout-table-column-px200')"> <!-- PRICE -->
          <p v-if="type == 'cart' && productIsInBasket(product)" class="mb-0">
            {{ addOnItemsByProductId[product.id].price | money }}
          </p>
          <p v-else-if="type == 'sale' && productIsInBasket(product)" class="mb-0">
            {{ addOnItemsByProductId[product.id].sold_for | money }}
          </p>
          <button v-else class="btn btn-block btn-dark-green" @click="addProduct(product)">
            <template v-if="($mq == 'xs' || $mq == 'sm')">
              Cart for {{ product.sale_price | money }}
            </template>
            <template v-else>
              Add to {{ type }} for {{ product.sale_price | money }}
            </template>
          </button>
        </div> <!-- /PRICE -->

        <div class="break mx-4" :class="idx == (roomProductsForRoomId.length - 1) ? 'pb-4' : ''"></div> <!-- FORCES NEW ROW -->
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    cart: {
      type: Object,
    },
    sale: {
      type: Object,
    },
    location: {
      type: Object,
      required: true,
    },
    locationChildPricing: {
      type: Boolean,
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
    roomProducts: {
      type: Array,
      required: true,
    },
    allowZeroAdults: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      divsModeNotTable: true,
      zero: 0,
    };
  },

  computed: {
    hasSomeFormOfChildPricing() {
      return this.pricingStyle == 'CHILD_TOTAL_PLAYERS' && this.item.cartable && this.item.cartable.room && ! this.item.cartable.room.pricing_disable_child
        || this.pricingStyle == 'CHILD_TOTAL_PLAYERS' && this.item.saleable && this.item.saleable.room_slot && ! this.item.saleable.room_slot.room.pricing_disable_child
        || this.locationChildPricing && this.item.cartable && this.item.cartable.room && ! this.item.cartable.room.pricing_disable_child
        || this.locationChildPricing && this.item.saleable && this.item.saleable.room_slot && ! this.item.saleable.room_slot.room.pricing_disable_child
    },

    disableReduceAdultQtyButton() {
      if (this.type == 'cart') {
        if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
          if (this.allowZeroAdults) {
            return this.item.options.adults == 0 || this.item.quantity == this.roomForItem.play_min;
          }
          return this.item.quantity == this.roomForItem.play_min || this.item.options.adults == 1;
        }
        return this.item.options.children > 0 ? this.item.options.adults <= 2 || (this.item.options.children + this.item.options.adults) <= this.roomForItem.play_min : this.roomForItem.play_min == this.item.quantity;
      } else if (this.type == 'sale') {
        if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
          if (this.allowZeroAdults) {
            this.thingable.adults == 0;
          }
          return this.thingable.players == this.roomForItem.play_min || this.thingable.adults == 1;
        }
        return (+this.thingable.children) > 0 ? this.thingable.adults <= 2 || ((+this.thingable.children) + this.thingable.adults) <= this.roomForItem.play_min : this.roomForItem.play_min == this.thingable.players;
      }
      return true;
    },

    disableIncreaseAdultQtyButton() {
      if (this.type == 'cart') {
        return this.thingable.availableRemainingTickets - this.item.quantity == 0;
      } else if (this.type == 'sale') {
        if (this.thingable.room_slot.public_booking === true) {
          return this.thingable.room_slot.availableRemainingTickets == 0;
        }
        return this.thingable.players >= this.thingable.room_slot.room.play_max; // new logic
      }
      return true;
    },

    disableReduceChildrenQtyButton() {
      if (this.type == 'cart') {
        if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
          return this.item.quantity == this.roomForItem.play_min || this.item.options.children == 0;
        }
        return this.item.options.children == 0 || this.item.options.adults <= 1 || this.roomForItem.play_min == this.item.quantity;
      } else if (this.type == 'sale') {
        if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
          return this.thingable.players == this.roomForItem.play_min || this.thingable.children == 0;
        }
        return +this.item.saleable.children == 0 || this.item.saleable.adults <= 1 || this.roomForItem.play_min == this.item.saleable.players;
      }
      return true;
    },

    disableIncreaseChildrenQtyButton() {
      if (this.type == 'cart') {
        return this.thingable.availableRemainingTickets - this.item.quantity == 0;
      } else if (this.type == 'sale') {
        if (this.thingable.room_slot.public_booking === true) {
          return this.thingable.room_slot.availableRemainingTickets == 0;
        }
        return this.thingable.players >= this.thingable.room_slot.room.play_max; // new logic
      }
      return true;
    },

    addOnItemsByProductId() {
      var items = {};

      if (this.type == 'cart') {
        this.cart.cart_items
          .filter(ci =>
            ci.cartable_type == 'App\\Models\\Product'
            && ci.options
            && ci.options.for_room_slot_ids
            && Object.keys(ci.options.for_room_slot_ids).map(Number).includes(this.itemRoomSlotId)
          )
          .forEach(ci => {
            items[ci.cartable.id] = JSON.parse(JSON.stringify(ci));
            items[ci.cartable.id].options.for_room_slot_id = this.itemRoomSlotId;
            items[ci.cartable.id].quantity = items[ci.cartable.id].options.for_room_slot_ids[this.itemRoomSlotId];
            items[ci.cartable.id].price = ci.price / ci.quantity * items[ci.cartable.id].quantity;
          });
      } else {
        this.sale.sale_items
          .filter(si =>
            si.saleable_type == 'App\\Models\\Product'
            && si.options
            && si.options.for_room_slot_id
            && si.options.for_room_slot_id == this.itemRoomSlotId
          )
          .forEach(si => items[si.saleable.id] = JSON.parse(JSON.stringify(si)));
      }

      return items;
    },

    forARoomSlot() {
      switch (this.type) {
      case 'cart':
        return this.thingable_type == 'App\\Models\\RoomSlot';
      case 'sale':
        return this.thingable_type == 'App\\Models\\Booking';
      default:
        return false;
      }
    },

    thingable() {
      switch (this.type) {
      case 'cart':
        return this.item.cartable;
      case 'sale':
        return this.item.saleable;
      default:
        return null;
      }
    },

    thingable_type() {
      switch (this.type) {
      case 'cart':
        return this.item.cartable_type;
      case 'sale':
        return this.item.saleable_type;
      default:
        return null;
      }
    },

    itemDeletable() {
      if (this.thingable_type == 'App\\Models\\Product' && this.thingable.name == 'Booking Fee') {
        return false;
      }

      if (this.type == 'sale') {
        return false;
      }

      if (this.type == 'sale' && this.sale.transactions.length) { // TODO: || PBL?
        return false;
      }

      if (this.type == 'sale' && this.sale.options && this.sale.options.pbl_expiry) {
        return false;
      }

      return true;
    },

    bookingQuantityEditable() {
      // just in case we change this logic in the future
      if (this.type == 'cart') {
        return false;
      }

      return ! this.itemDeletable;
    },

    itemQuanityEditable() {
      if (this.thingable_type == 'App\\Models\\Product' && this.thingable.type == 'CHARGE') {
        return false;
      }
      if (this.thingable_type == 'App\\Models\\VoucherProduct' && this.thingable.type == 'M' && this.thingable.amount == 1) {
        return false;
      }

      return true;
    },

    roomQuestions() {
      return this.location.rooms.filter(r => r.room_questions.length)
        .reduce((map, obj) => {
          map[obj.id] = obj.room_questions;
          return map;
        }, {});
    },

    isMinQuanity() {
      if (this.type == 'cart' && this.forARoomSlot) {
        if (this.thingable.room.play_min == this.item.quantity) {
          return true;
        }
      } else if (this.type == 'sale' && this.forARoomSlot) {
        if (this.thingable.room_slot.room.play_min == this.thingable.players) {
          return true;
        }
      } else if (this.type == 'cart' && this.item.quantity < 1) {
         return true;
      } else if (this.type == 'sale' && this.item.quantity < 1) {
        return true;
      }
      return false;
    },

    isMaxQuanity() {
      if (this.type == 'cart' && this.forARoomSlot) {
        if (this.thingable.room.play_max == this.item.quantity) {
          return true;
        }
      } else if (this.type == 'sale' && this.forARoomSlot) {
        if (this.thingable.room_slot.room.play_max == this.thingable.players) {
          return true;
        }
      } else if (this.type == 'cart' && this.item.quantity < 99999) {
        return true;
      } else if (this.type == 'sale' && this.item.quantity < 99999) {
        return true;
      }
      return false;
    },

    itemRoomId() {
      if (! this.forARoomSlot) {
        return null;
      }
      switch (this.type) {
      case 'cart':
        return this.thingable.room_id;
      case 'sale':
        return this.thingable.room_slot.room_id;
      default:
        return null;
      }
    },

    itemRoomSlotId() {
      if (! this.forARoomSlot) {
        return null;
      }
      switch (this.type) {
      case 'cart':
        return this.thingable.id;
      case 'sale':
        return this.thingable.room_slot.id;
      default:
        return null;
      }
    },

    roomForItem() {
      if (! this.forARoomSlot) {
        return null;
      }
      switch (this.type) {
      case 'cart':
        return this.thingable.room;
      case 'sale':
        return this.thingable.room_slot.room;
      default:
        return null;
      }
    },

    roomProductsForRoomId() {
      if (this.itemRoomId == null) {
        return [];
      }

      return this.roomProducts.filter(roomProduct =>
        roomProduct.rooms.some(room => room.id == this.itemRoomId && room.pivot.visible)
      );
    },
  },

  methods: {
    productIsInBasket(product) {
      return this.addOnItemsByProductId.hasOwnProperty(product.id);
    },

    addProduct(product) {
      // console.log('ItemDetailsRow::addProduct', product);
      this.$emit('add-product', product, this.itemRoomSlotId);
    },

    removeItemButton() {
      // console.log('removeItemButton');

      const self = this;

      $('.destroy-item').confirmation('dispose');
      $('.destroy-item').removeClass('destroy-item');
      event.target.classList.add('destroy-item');

      // confirmation popover
      let options = {
        container: 'body',
        rootSelector: '.destroy-item',
        title: 'Delete this item?',
        popout: true,
        singleton: true,
        btnOkClass: 'btn btn-sm btn-green',
        btnCancelClass: 'btn btn-sm btn-red',
        placement: 'right',
        trigger: 'manual',
        onConfirm(value) {
          event.target.classList.remove('destroy-item');

          self.$nextTick(function () {
            self.removeItem();
          });
        },
        onCancel(value) {
          event.target.classList.remove('destroy-item');
        },
      };

      $('.destroy-item').confirmation(options);
      $('.destroy-item').on('hidden.bs.confirmation', function (event) {
        event.target.classList.remove('destroy-item');
      });
      $('.destroy-item').confirmation('show');
    },

    removeItem(itemPassed = false) {
      // console.log('removeItem()');

      let request = {
        location: this.location.slug,
      }

      if (this.type == 'cart') {
        var axiosRoute = this.route('api.cart.cart-items.destroy', {cart: this.cart, cartItem: itemPassed ? itemPassed : this.item});
      } else {
        var axiosRoute = this.route('api.sale-items.public-destroy', itemPassed ? itemPassed : this.item);
      }

      this.loading(true);

      axios.delete(axiosRoute, {data: request})
        .then((response) => {
          if (response.status == 200) {
            if (this.type == 'cart') {
              this.$emit('cart-updated', response.data);
            } else {
              this.$emit('sale-updated', response.data);
            }
          } else {
            flash('Error removing Item from ' + this.type.charAt(0).toUpperCase() + this.type.slice(1), 'danger');
            console.log('removeItem', response.data);
            console.log('removeItem', response.status);
            console.log('removeItem', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error removing RoomSlot from Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('removeItem:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('removeItem:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('removeItem:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('removeItem:401', error.response.data);
            } else {
              console.log('removeItem: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('removeItem: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('removeItem: Error', error.message);
          }
          this.loading(false);
        });
    }, // removeItem()

    itemAddOnQuantityChanged(addOnItem, quantityChange) {
      // console.log('itemAddOnQuantityChanged', addOnItem, quantityChange);

      if (addOnItem.quantity + quantityChange > 0) {
        return this.updateItem(addOnItem, quantityChange);
      }

      if (this.type == 'sale') {
        // saleItem is one per RoomProduct per room_slot, so we can safely remove it
        return this.removeItem(addOnItem);
      }

      // cartItem is combine RoomProduct for multiple room_slots, so we can only remove if we are the last item to be removed
      let addOnItemTotalQty = Object.values(addOnItem.options.for_room_slot_ids).reduce((a, b) => a + b, 0);
      let addOnItemQtyForThisRoomSlotID = addOnItem.options.for_room_slot_ids[this.itemRoomSlotId];

      let totalQtyAfterChange = addOnItemTotalQty + quantityChange;
      let qtyForThisRoomSlotIDAfterChange = addOnItemQtyForThisRoomSlotID + quantityChange;

      if (totalQtyAfterChange <= 0 && qtyForThisRoomSlotIDAfterChange <= 0) {
        // safe to remove item
        return this.removeItem(addOnItem);
      }

      return this.updateItem(addOnItem, quantityChange);
    },

    itemQuantityChanged(amount) {
      // console.log('itemQuantityChanged', amount);
      if (parseInt(this.item.quantity) + parseInt(amount) == 0) {
        this.removeItem();
      } else {
        this.item.quantity = parseInt(this.item.quantity) + parseInt(amount);
      }

      this.updateItem();
    },

    itemAdultsChanged(amount) {
      // console.log('itemAdultsChanged', amount);
      if (this.type == 'cart') {
        this.item.options.adults = parseInt(this.item.options.adults) + parseInt(amount);
        this.item.quantity = parseInt(this.item.quantity) + parseInt(amount);

        this.updateItem();
      } else {
        this.thingable.adults = parseInt(this.thingable.adults) + parseInt(amount);
        this.thingable.players = parseInt(this.thingable.players) + parseInt(amount);

        this.updateSaleItemPlayers();
      }
    }, // itemAdultsChanged()

    itemChildrenChanged(amount) {
      // console.log('itemChildrenChanged', amount);
      if (this.type == 'cart') {
        this.item.options.children = parseInt(this.item.options.children) + parseInt(amount);
        this.item.quantity = parseInt(this.item.quantity) + parseInt(amount);
        this.updateItem();
      } else {
        this.thingable.children = parseInt((+this.thingable.children)) + parseInt(amount);
        this.thingable.players = parseInt(this.thingable.players) + parseInt(amount);

        this.updateSaleItemPlayers();
      }
    }, // itemChildrenChanged()

    updateSaleItemPlayers() {
      // console.log('updateSaleItemPlayers');

      let request = {
        adults: this.thingable.adults,
        children: this.thingable.children,
      };

      this.loading(true);
      axios.patch(this.route('api.sale-items.public-update', this.item), request)
        .then((response) => {
          if (response.status == 200) {
            // console.log('response.status', response.status);

            this.$emit('sale-updated', response.data);
          } else {
            flash('Error updating SaleItem', 'danger');
            console.log('saleUpdateSaleItem', response.data);
            console.log('saleUpdateSaleItem', response.status);
            console.log('saleUpdateSaleItem', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error updating SaleItem', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('saleUpdateSaleItem:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('saleUpdateSaleItem:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('saleUpdateSaleItem:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('saleUpdateSaleItem:401', error.response.data);
            } else {
              console.log('saleUpdateSaleItem: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('saleUpdateSaleItem: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('saleUpdateSaleItem: Error', error.message);
          }
          this.loading(false);
        });
    }, // saleUpdateSaleItem()

    updateItem(itemPassed = false, quantityChange = null) {
      // console.log('updateItem', itemPassed, quantityChange);

      if (this.type == 'cart') {
        var axiosRoute = this.route('api.cart.cart-items.update', {cart: this.cart, cartItem: itemPassed ? itemPassed : this.item});
      } else {
        var axiosRoute = this.route('api.sale-items.public-update', itemPassed ? itemPassed : this.item);
      }

      if (itemPassed) {
        var request = {
          location: this.location.slug,
          quantity: parseInt(itemPassed.quantity) + parseInt(quantityChange),
          options: itemPassed.options,
          notes: itemPassed.notes,
        };
      } else {
        var request = {
          location: this.location.slug,
          quantity: Math.max(1, this.item.quantity), // min quantity 1
          options: this.item.options,
          soldFor: this.item.sold_for,
          notes: this.item.notes,
        };
      }

      this.loading(true, this.$refs.checkoutTableRow);

      axios.patch(axiosRoute, request)
        .then((response) => {
          if (response.status == 200) {
            if (this.type == 'cart') {
              this.$emit('cart-updated', response.data);
            } else {
              this.$emit('sale-updated', response.data);
            }
          } else {
            flash('Error updating Item', 'danger');
            console.log('updateItem', response.data);
            console.log('updateItem', response.status);
            console.log('updateItem', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error updating Item', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('updateItem:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('updateItem:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('updateItem:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('updateItem:401', error.response.data);
            } else {
              console.log('updateItem: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('updateItem: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('updateItem: Error', error.message);
          }
          this.loading(false);
        });
    }, // updateItem()

    keyBy(array, key) {
      return (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});
    },
  },
}
</script>
